/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDtmKadDocCreateRequest } from '../types/PatchedDtmKadDocCreate';
import type { DtmKadDocCreateResponse } from '../types/DtmKadDocCreate';

export type DtmKadDocsSendToDmvsPartialUpdateRequest = PatchedDtmKadDocCreateRequest;
export type DtmKadDocsSendToDmvsPartialUpdateResponse = DtmKadDocCreateResponse;

export type DtmKadDocsSendToDmvsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dtm_kad_docs/{id}/send_to_dmvs/
 *
 * ```yaml
 * operationId: dtm_kad_docs_send_to_dmvs_partial_update
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsSendToDmvsPartialUpdateOperation = ({
  id,
  ...rest
}: DtmKadDocsSendToDmvsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dtm_kad_docs/${id}/send_to_dmvs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dtm_kad_docs/{id}/send_to_dmvs/' };
  };

/**
 * PATCH /dmx-server/dtm_kad_docs/{id}/send_to_dmvs/
 *
 * ```yaml
 * operationId: dtm_kad_docs_send_to_dmvs_partial_update
 * tags:
 *   - dtm_kad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmKadDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmKadDocCreate'
 *     description: ''
 * ```
 */
export const dtmKadDocsSendToDmvsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmKadDocsSendToDmvsPartialUpdateQuery;
  request: PatchedDtmKadDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmKadDocCreateResponse>> => {
  const operation = dtmKadDocsSendToDmvsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
